import { z } from 'zod';
/** Route params for the provider directory's internal-data endpoints. */
export const OrganizationProviderParamsSchema = z
    .object({ organizationId: z.uuid(), providerId: z.uuid() })
    .strict();
/** Notes staff keep on a provider. The empty string is how the notes are cleared. */
export const OrganizationProviderInternalDataBodySchema = z
    .object({ providerNotes: z.string() })
    .strict();
//# sourceMappingURL=provider.js.map